import { StoreState } from '@/redux/types';

export const getQuantityDiscounts = (state: StoreState, quantity: number) =>
  state.discounts.quantity[quantity];
